module.exports = __webpack_public_path__ + "static/img/logo14.c902804f.png";